import { render } from "./TeamView.vue?vue&type=template&id=bcd4bd4c"
import script from "./TeamView.vue?vue&type=script&lang=js"
export * from "./TeamView.vue?vue&type=script&lang=js"

import "./TeamView.vue?vue&type=style&index=0&id=bcd4bd4c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__